<template>
    <el-dialog title="优惠券使用规则" :visible.sync="dialogFormVisible" @close="getRuleList" center append-to-body>
        <el-tabs type="border-card" @tab-click="handleClick" v-model="ruleTabSel">
            <template v-for="(item,index) in ruleTabs">
                <el-tab-pane :label="item.label" :name="item.value">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                             :size="GCONFIG.styleElFormSize">
                        <el-form-item label="名称">
                            <el-input v-model="formInline.name" placeholder="输入名称查询"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getCashRuleItemList">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-table
                                    ref="multipleTable"
                                    :data="cashRuleItemList"
                                    tooltip-effect="dark"
                                    style="width: 100%"
                                    v-loading="loading"
                                    @selection-change="handleSelectionChange" label="可选列表">
                                <template slot="header" slot-scope="scope">
                                    <span>可选列表</span>
                                </template>
                                <el-table-column
                                    label="标识"
                                    width="120">
                                    <template slot-scope="scope">{{ scope.row.id }}</template>
                                </el-table-column>
                                <el-table-column
                                    prop="name"
                                    label="名称">
                                </el-table-column>
                                <el-table-column
                                    prop="salePrice" v-if="formInline.itemId==3||formInline.itemId==6"
                                    label="销售价"
                                ></el-table-column>
                                <el-table-column v-if="formInline.itemId==3||formInline.itemId==6"
                                    prop="createTime"
                                    label="创建时间"
                                >
                                </el-table-column>
                                <el-table-column label="操作" fixed="right" width="120">
                                    <template slot-scope="scope">
                                        <el-button type="success" size="mini" @click="save(scope.row,item.value,3)">设置可用</el-button>
                                        <!-- <el-button type="warning" size="mini" @click="save(scope.row,item.value,-1)">设置不可用</el-button> -->
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="pagination-wrap">
                                <el-pagination
                                        background
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page="formInline.currentPage"
                                        :page-sizes="GCONFIG.pageSizes"
                                        :page-size="formInline.pageSize"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="formInline.recordsTotal">
                                </el-pagination>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <el-table :data="checkedCashRuleItemList" stripe border center v-loading="loading" label="已选列表">
                                <template slot="header" slot-scope="scope">
                                    <span>已选列表</span>
                                </template>
                                <el-table-column prop="id" label="标识"></el-table-column>
                                <el-table-column prop="name" label="规则对象" width="150">
                                </el-table-column>
                                <el-table-column prop="stats" label="是否可用券">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.stats" clearable filterable >
                                            <el-option
                                                    v-for="item in ruleStatusList"
                                                    :key="item.value"
                                                    :label="item.name"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="mini" @click="deleteRule(scope.row)">删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </template>
        </el-tabs>
    </el-dialog>
</template>

<script>
    import {
        getCashRuleItemListApi,
        saveCashRuleList2Api,
        getSelectCashRuleItemList,
        saveCashRuleNew,
        deleteCashRuleDetail,
        getCashRuleStatusList,
        saveCashRuleListApi
    } from '@/api/api'
    export default{
        data(){
            return {
                ticketBatchId: this.$route.query.cashId,
                ruleTabSel: '6',
                ruleTabs: [
                    {label: '单品', value: '6'},
                    {label: '促销', value: '3'},
                    {label: '产品类目', value: '8'},
                    {label: '会员类型', value: '100'},
                ],
                formInline: {
                    itemId: 6,
                    ticketBatchId: '',
                    currentPage: 1,
                    pageSize: 15,
                    name: ''
                },
                loading: false,
                ruleStatusList:[],
                historySelected: [],//历史选择的
                cashRuleItemList: [],//规则项列表
                checkedCashRuleItemList: []  // 已选中的
            }
        },
        mounted(){
            this.formInline.ticketBatchId = this.ticketBatchId;
            this.getCashRuleItemList();
            this.getSelectRule();
            this.getCashRuleList()
        },
        props: ['dialogFormVisible'],
        methods: {
            getCashRuleItemList(){
                this.loading = true;
                getCashRuleItemListApi(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        //this.checkedCashRuleItemList = res.data.value.select;
                        this.formInline.recordsTotal = res.data.value.all.total;
                        this.cashRuleItemList = res.data.value.all.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSelectionChange(val){
                this.checkedCashRuleItemList = val;
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCashRuleItemList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCashRuleItemList()
            },
            getCashRuleList(){
                this.loading = true;
                getCashRuleStatusList().then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.ruleStatusList = res.data.value;
                    }
                })
            },
            sureAct() {
                let flag = true;
                let msg = '';
                if (this.historySelected.length > 0) {
                    //保存历史选择
                    for (let j = 0; j < this.historySelected.length; j++) {
                        for (let i = 0; i < this.checkedCashRuleItemList.length; i++) {
                            if (this.historySelected[j].id === this.checkedCashRuleItemList[i].id) {
                                flag = false;
                                msg = msg + this.checkedCashRuleItemList[i].name + ',';
                            }
                        }
                    }
                }
                if (!flag) {
                    if (msg.endsWith(',')) {
                        msg = msg.substring(0, msg.length - 1);
                    }
                    this.$message({
                        showClose: true,
                        message: msg + '已存在!',
                        type: 'error'
                    });
                    return;
                }
                if (this.checkedCashRuleItemList.length == 0) {
                    this.$message({
                        showClose: true,
                        message: '请选择规则项',
                        type: 'error'
                    });
                } else {
                    saveCashRuleList2Api({
                        list: encodeURIComponent(JSON.stringify(this.checkedCashRuleItemList)),
                        ruleTypeId: this.formInline.itemId,
                        ticketBatchId: this.formInline.ticketBatchId
                    }).then(res => {
                        if (res.data.status == 200) {
                            this.designTable = false;
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.checkedCashRuleItemList = [];
                            this.cashRuleItemList = [];
                            this.historySelected = [];
                            this.$emit('closeRuleDialog', false)
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            returnHistory(){
                window.history.back();
            },
            deleteRule(row){
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteCashRuleDetail({
                        ruleDetailId: row.ruleDetailId,
                        ticketBatchId: this.formInline.ticketBatchId,
                        ruleType: this.formInline.itemId,
                    }).then(res => {
                        if (res.data.status == 200) {
                            this.getSelectRule();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                })
            },
            selectAll(){
                //全选
                for (var j = 0; j < this.cashRuleItemList.length; j++) {
                    if (this.checkedCashRuleItemList.length > 0) {
                        for (var i = 0; i < this.checkedCashRuleItemList.length; i++) {
                            if (this.checkedCashRuleItemList[i].id === this.cashRuleItemList[j].id) {
                                this.$message({
                                    showClose: true,
                                    message: this.cashRuleItemList[j].name + '已存在',
                                    type: 'error'
                                });
                                return;
                            }
                        }
                    }
                }
                for (var j = 0; j < this.cashRuleItemList.length; j++) {
                    let ruleItem = {};
                    ruleItem.id = this.cashRuleItemList[j].id;
                    ruleItem.name = this.cashRuleItemList[j].name;
                    this.checkedCashRuleItemList.push(ruleItem);
                }
            },
            selectRule(row){
                for (var i = 0; i < this.checkedCashRuleItemList.length; i++) {
                    if (this.checkedCashRuleItemList[i].id === row.id) {
                        this.$message({
                            showClose: true,
                            message: row.name + '已存在',
                            type: 'error'
                        });
                        return;
                    }
                }
                //选择优惠券规则
                let ruleItem = {};
                ruleItem.id = row.id;
                ruleItem.name = row.name;
                this.checkedCashRuleItemList.push(ruleItem);
            },
            getSelectRule(){
                this.loading = true;
                getSelectCashRuleItemList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.checkedCashRuleItemList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            save(row,itemType,stats){
                for (var i = 0; i < this.checkedCashRuleItemList.length; i++) {
                    if (this.checkedCashRuleItemList[i].id === row.id) {
                        this.$message({
                            showClose: true,
                            message: row.name + '已存在',
                            type: 'error'
                        });
                        return;
                    }
                }
                this.loading = true;
                saveCashRuleNew({
                    ruleDetailId: row.id,
                    ruleTypeId: this.formInline.itemId,
                    itemType:0,
                    stats:stats,
                    ticketBatchId: this.formInline.ticketBatchId
                }).then(res => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.designTable = false;
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getSelectRule();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getRuleList(){
                this.$emit('closeRuleDialog', false)
            },
            handleClick(){
                this.formInline.itemId = this.ruleTabSel
                if(this.formInline.itemId==8||this.formInline.itemId=='8'){
                    this.formInline.pageSize=50
                }
                this.getCashRuleItemList()
                this.getSelectRule();
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .pic-wrap {
        padding: 10px;
    }

    .header-return {
        margin-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 10px;
        position: relative;
        h2 {
            text-align: center;
            position: absolute;
            left: 50%;
            top: 0;
            margin: 0;
        }
    }

    .pic-btn-wrap {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        p {
            color: #e50011;
            font-size: 20px;
            margin: 0;
        }
    }

    .header-btn {
        margin-left: 20px;
        font-size: 24px;
        font-weight: bold;
        padding: 5px 10px;
    }

    .drag-container {
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #606266;
        border-spacing: 0;
        border-collapse: collapse;
        img {
            width: 70px;
            height: 70px;
        }
        td, th {
            padding: 12px 0;
            border: 1px solid #EBEEF5;

        }
        th {
            background: #eef1f6;
            color: #222222;
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/coupon/cashProductRule.vue